import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { _get, _post, _put } from "../../services/apiClient";
import { Button, Form, Spinner, Card } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";

interface Item {
  id?: number;
  name: string;
  category: string;
  price: number;
  stock: number;
  description: string;
}

export default function SampleForm() {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const isEditMode = Boolean(id);

  const [formData, setFormData] = useState<Item>({
    name: "",
    category: "",
    price: 0,
    stock: 0,
    description: "",
  });
  const [loading, setLoading] = useState<boolean>(isEditMode);

  const fetchItem = async () => {
    try {
      const res = await _get<Item>(`/items/${id}`);
      setFormData(res.data);
    } catch (err) {
      console.error("Failed to fetch item:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isEditMode) fetchItem();
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (isEditMode) {
        await _put(`/items/${id}`, formData);
        alert("Item updated successfully!");
      } else {
        await _post("/items", formData);
        alert("Item created successfully!");
      }
      navigate("/items");
    } catch (err) {
      console.error("Failed to save item:", err);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">
        {isEditMode ? "Edit Item" : "Add New Item"}
      </h1>

      <Card className="shadow-sm">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Item Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                name="category"
                value={formData.category}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                min={0}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Stock</Form.Label>
              <Form.Control
                type="number"
                name="stock"
                value={formData.stock}
                onChange={handleChange}
                min={0}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                rows={3}
                value={formData.description}
                onChange={handleChange}
              />
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                className="me-2"
                onClick={() => navigate("/items")}
              >
                Cancel
              </Button>
              <Button variant="success" type="submit">
                <FeatherIcon icon="save" size={16} />{" "}
                {isEditMode ? "Update Item" : "Create Item"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
